import Link from 'next/link'

import { ACADEMY_BASE_PATH } from '@/utilities/academyBasePath'
import type { AcademyCourseCardData } from '@/utilities/getAcademyHome'
import { formatCourseMeta } from '@/utilities/academyCourseMeta'
import { AcademyCourseIllustration } from './AcademyCourseIllustration'

interface Props {
  course: AcademyCourseCardData
}

export function AcademyCourseCard({ course }: Props) {
  return (
    <Link
      href={`${ACADEMY_BASE_PATH}/${course.slug}`}
      className="group flex h-full w-full flex-col justify-between rounded-[16px] border border-civo-cloud bg-white p-6 transition-[background-color,box-shadow] duration-300 hover:bg-civo-cloud/50 hover:shadow-[0px_6px_8px_0px_rgba(0,0,0,0.08)]"
    >
      {/* Card content */}
      <div className="flex w-full flex-col gap-4 pb-4">
        <div className="flex h-40 w-full items-center justify-center overflow-hidden rounded-[12px] bg-civo-cloud transition-colors duration-300 group-hover:bg-civo-cloud-dark">
          <AcademyCourseIllustration
            illustration={course.illustration}
            className="size-[128px] object-contain transition-transform duration-300 group-hover:scale-[1.2]"
          />
        </div>

        {/* Title - display-compact-medium (30px, scaling to 36px at md+) */}
        <h3 className="display-compact-medium leading-normal mb-0">
          {course.courseName || course.title}
        </h3>

        {course.summary && (
          <p className="body-small mb-0 text-black/70 line-clamp-3">{course.summary}</p>
        )}
      </div>

      {/* Card meta */}
      <div className="flex w-full items-center justify-between pt-2">
        <span className="subheading-xsmall text-civo-dark-gray">
          {formatCourseMeta({ count: course.lessonCount, totalMinutes: course.totalMinutes })}
        </span>
        <span className="subheading-xsmall inline-flex items-center gap-2 transition-[gap] group-hover:gap-3">
          Start course
          <svg width="12" height="12" viewBox="0 0 8 8" fill="none" aria-hidden="true" className="size-3">
            <path d="M4 8L3.2875 7.3L6.0875 4.5H0V3.5H6.0875L3.2875 0.7L4 0L8 4L4 8Z" fill="currentColor" />
          </svg>
        </span>
      </div>
    </Link>
  )
}
